import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { StatusType } from '../../util';

@Component({
  selector: 'lib-status-icon',
  imports: [NgClass],
  templateUrl: './status-icon.html',
  styleUrl: './status-icon.scss',
})
export class StatusIcon {
  public type = input<StatusType>('info');
  public icon = input<string>('pi-info-circle');
  public size = input<'sm' | 'md' | 'lg'>('sm');
}
